
<script lang="ts">
import ContextFiles from "./ContextFiles.svelte";
import UploadFile from "./UploadFile.svelte";

export let contextId:string;
let contextFiles: ContextFiles;


function addFileToArray(){
    contextFiles.reload();
}

</script>

<div class="row">
    <div class="col-8 mb-3">
        <h5>Listado</h5>
    </div>
    <div class="col-4 text-end">
        <UploadFile contextId={contextId} on:upload={ addFileToArray }/>
    </div>
    <div class="col-12">
        <ContextFiles contextId={contextId} bind:this={contextFiles} />
    </div>
</div>




